/*
  Collection filter drawer, phone and tablet only.
  - Locks the page behind while the drawer is open (iOS ignores overflow:hidden on body).
  - Swipe down on the sheet to close it, the way iOS sheets work. Closing goes through the
    existing .js-filterClose button so collectionFilter.min.js keeps its own state in step.
*/
(function () {
  // Style tiles: a full-width strip at the top of the collection intro, then the intro text, then
  // Filter and Sort (moved out of the nav row, which collapses). Each tile is a label for the
  // drawer's Style checkbox; the ticked one is marked. Arrows appear on desktop when it overflows.
  var tiles = document.querySelector('.js-styleTiles');
  if (tiles) {
    var block = document.querySelector('.collection__image-filter');
    var wrap = document.createElement('div');
    wrap.className = 'style-tiles-wrap';
    tiles.parentNode.insertBefore(wrap, tiles);
    wrap.appendChild(tiles);

    if (block) {
      block.classList.add('has-style-tiles');
      block.insertBefore(wrap, block.firstChild);
      var textColumn = block.querySelector('.collection__image-filter__column--text');
      var buttons = document.querySelectorAll('.js-filterButton, .js-sortButton');
      var nav = document.querySelector('.collection__nav');
      if (textColumn && buttons.length) {
        var actions = document.createElement('div');
        actions.className = 'style-tiles-actions';
        buttons.forEach(function (button) { actions.appendChild(button); });
        textColumn.appendChild(actions);
        if (nav) nav.classList.add('has-moved-actions');
      }
    }

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'style-tiles__arrow style-tiles__arrow--prev';
    next.className = 'style-tiles__arrow style-tiles__arrow--next';
    prev.setAttribute('aria-label', 'Previous styles');
    next.setAttribute('aria-label', 'More styles');
    prev.textContent = '\u2190';
    next.textContent = '\u2192';
    wrap.appendChild(prev);
    wrap.appendChild(next);
    var step = function (dir) { tiles.scrollBy({ left: dir * tiles.clientWidth * 0.8, behavior: 'smooth' }); };
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    var syncArrows = function () {
      var overflow = tiles.scrollWidth > tiles.clientWidth + 1;
      wrap.classList.toggle('is-scrollable', overflow);
      prev.disabled = tiles.scrollLeft <= 1;
      next.disabled = tiles.scrollLeft + tiles.clientWidth >= tiles.scrollWidth - 1;
    };
    tiles.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();

    var syncTiles = function () {
      tiles.querySelectorAll('.style-tiles__tile').forEach(function (tile) {
        var box = document.getElementById(tile.htmlFor);
        tile.classList.toggle('is-active', !!(box && box.checked));
      });
    };
    syncTiles();
    document.addEventListener('change', syncTiles);
    document.addEventListener('click', function () { setTimeout(syncTiles, 0); });
  }

  var drawer = document.querySelector('.js-filterForm.filter-drawer');
  if (!drawer) return;

  var mobile = window.matchMedia('(max-width: 1023px)');
  var body = drawer.querySelector('.filter-drawer__body');
  var closeButton = drawer.querySelector('.filter-drawer__close');
  var overlay = document.querySelector('.js-filterOverlay');
  var lockedAt = null;

  function lockPage() {
    if (lockedAt !== null || !mobile.matches) return;
    lockedAt = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedAt + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }

  function unlockPage() {
    if (lockedAt === null) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, lockedAt);
    lockedAt = null;
  }

  new MutationObserver(function () {
    if (drawer.classList.contains('active')) lockPage();
    else unlockPage();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  var startY = 0;
  var startTime = 0;
  var offset = 0;
  var tracking = false;
  var dragging = false;

  drawer.addEventListener('touchstart', function (event) {
    if (!mobile.matches || !drawer.classList.contains('active')) return;
    var inList = body.contains(event.target);
    // Inside the list, only drag once it is scrolled to the top; otherwise let it scroll.
    tracking = !inList || body.scrollTop <= 0;
    dragging = false;
    offset = 0;
    startY = event.touches[0].clientY;
    startTime = Date.now();
  }, { passive: true });

  drawer.addEventListener('touchmove', function (event) {
    if (!tracking) return;
    var delta = event.touches[0].clientY - startY;
    if (!dragging) {
      if (delta <= 0) { tracking = false; return; }
      dragging = true;
      drawer.style.transition = 'none';
    }
    event.preventDefault();
    offset = Math.max(0, delta);
    drawer.style.transform = 'translateY(' + offset + 'px)';
    if (overlay) overlay.style.opacity = String(0.4 * (1 - offset / drawer.offsetHeight));
  }, { passive: false });

  function endDrag() {
    if (!dragging) { tracking = false; return; }
    var speed = offset / Math.max(1, Date.now() - startTime);
    var shouldClose = offset > drawer.offsetHeight * 0.25 || speed > 0.6;
    // A released swipe carries its own speed, so it finishes faster than the x button.
    drawer.style.transition = shouldClose ? 'transform 0.3s cubic-bezier(0.25, 0.9, 0.3, 1)' : '';
    drawer.style.transform = '';
    if (overlay) overlay.style.opacity = '';
    if (shouldClose) {
      closeButton.click();
      setTimeout(function () { drawer.style.transition = ''; }, 350);
    }
    tracking = false;
    dragging = false;
  }

  drawer.addEventListener('touchend', endDrag);
  drawer.addEventListener('touchcancel', endDrag);
})();
